import { createFileRoute } from "@tanstack/react-router";

import PaymentList from "@/pages/payment/PaymentList";

export const Route = createFileRoute("/payment/")({
  component: PaymentList,
});
